<template>
  <div id="topicList">
    <div class="allSearch">
      <div class="newSearch d_flex">
        <div style="width: auto;white-space: normal">
          <p>
            <input class="allInput" v-model="searchFrom.topicName" type="text" placeholder="话题名称">
          </p>


          <button @click="getTagList(1)" class="redButtonTwo">搜索</button>
        </div>
        <div style="width: auto">
          <button class="redButtonTwo" @click="newTopic">新建</button>
        </div>
      </div>
    </div>
    <div class="allTablePlace">
      <div style="overflow:auto; width: 100%;">
        <table cellspacing="0" class="allTable" :style="tagList.length > 0 ? 'width: 100%;' : 'width: 100%;'">
          <thead>
          <tr>
            <th class="t_c">话题名称</th>
            <th class="t_c">备注</th>
            <th class="t_c">操作人</th>
            <th class="t_c">操作时间</th>
            <th class="t_c">操作</th>
          </tr>
          </thead>
          <tbody>
            <template v-if="tagList.length > 0">
              <tr :key="index" v-for="(item, index) in tagList">
                <td width="10%" class="t_c NoWrap"  :title="item.topicName">{{item.topicName}}</td>
                <td width="15%" class="t_c NoWrap"  :title="item.remark" >{{item.remark}}</td>
                <td width="10%" class="t_c NoWrap"  :title="item.lastModifyName">{{item.lastModifyName}}</td>
                <td width="10%" class="t_c NoWrap"  :title="item.lastModificationTime">{{item.lastModificationTime}}</td>
                <td width="15%" class="t_c">
                  <div class="icon more iconfont icongengduo moreOperations">
                    <ul>
                      <li @click="editTag(item)">编辑</li>
                      <li @click="deleteTag(item)">删除</li>
                    </ul>
                  </div>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td style="border: none; text-align: center;" :colspan="8">暂无数据</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <page v-if="totalPage !== 0" :totalCount="totalCount" v-on:on-getList="getTagList($event)" :totalPage="totalPage" :page="page" :explain="0"></page>
    </div>
    
    <!-- 新建标签 -->
    <model v-if="showModel" :buttonType="0" :title="modelTitle" :minWidth="'500px'" v-on:on-cancel="cancelModel()" v-on:on-confirm="confirModel()">
      <div style="height:150px;width:100%; box-sizing:border-box; padding:10px 40px;">
        <ul class="allUL">
          <li>
            <span style="font-size:16px"><i class="colorRed m_r_5">*</i>话题名称</span>
            <input v-model="addFrom.name" maxlength="50"  type="text" class="allInput" style="width: calc(100% - 110px); margin-left: -30px;" placeholder="请输入话题名称" />
          </li>
          <li>
            <span style="font-size:16px;margin-left: 14px;">备注</span>
            <input v-model="addFrom.remark" maxlength="150"  type="text" class="allInput" style="width: calc(100% - 110px); margin-left: -44px;" placeholder="请输入备注" />
          </li>
        </ul>
      </div>
    </model>
      
  </div>
</template>
<script>
export default {
  name: 'topicList',
 data () {
  return {
    searchFrom:{
      topicName:''
    },
    addFrom:{
      name:'',
      remark:''
    },
    tagList:[],
      page: 1,
      pageSize: 10,
      totalPage: 0,
      totalCount: 0,
      showModel:false,
      modelTitle:'',
      id:null
  }
 },
 created () {
  this.getDemoDatas()
 },
 methods: {
  getDemoDatas(){
    let params = {
        pageIndex: 1,
        pageSize: 10
      }

      this.page=1
      this.pageSize= 10
      this.totalPage=0
      this.totalCount= 0

      const data = {
        topicName:''
      }
      let url = this.$commonJs.returnQuery('/api/topic/GetTopicsList', data)

    this.$axiox.post(url, params).then(res => {
        console.log(res, '获取话题列表')
        if (res && res.data.length > 0) {
          this.tagList = res.data
          this.totalCount = res.total
          this.totalPage = Math.ceil(res.total / this.pageSize)
        } else {
          this.tagList = []
          this.totalCount = 0
          this.totalPage = 0
        }
      })
  },
  getTagList (page) {
    
      this.page = page
      let data = JSON.parse(JSON.stringify(this.searchFrom))
      console.log(data)

      let params = {
        pageIndex: page,
        pageSize: this.pageSize
      }
      // 转义
      // let url = this.$commonJs.returnQuery('/api/topic/GetTopicsList', data)
      // this.$axiox.post(url, params).then(res => {
        this.$axiox.post('/api/topic/GetTopicsList', {
          topicName:this.searchFrom.topicName,
          pageIndex: page,
          pageSize: this.pageSize
        }).then(res => {
        console.log(res, '获取话题列表')
        if (res && res.data.length > 0) {
          this.tagList = res.data
          this.totalCount = res.total
          this.totalPage = Math.ceil(res.total / this.pageSize)
        } else {
          this.tagList = []
          this.totalCount = 0
          this.totalPage = 0
        }
      })
    },
    newTopic(){
      this.id = null
      this.addFrom={
          name:'',
          remark:''
        }
      this.modelTitle = '新建话题'
      this.showModel = true
    },
    confirModel(){
      if(!this.addFrom.name){
        this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: '请检查必填项',
            stayTime: 5
          })
          return false
      }

      if(this.id){
        const objs = {
          id:this.id,
          name:this.addFrom.name,
          remark:this.addFrom.remark
        }

        this.$axiox.post('/api/topic/UpdTopic', objs).then(res => {
        if (res.data) {
          this.$commonJs.alertTips({
            type: 'success',
            title: '成功',
            content: '编辑成功',
            stayTime: 5
          })
          this.showModel = false
          this.getDemoDatas()
        } else {
          this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: res.message || '请检查必填项',
            stayTime: 5
          })
        }
      })


      }else{
        const objs = this.addFrom
        this.$axiox.post('/api/topic/AddTopic', objs).then(res => {
        if (res.data) {
          this.$commonJs.alertTips({
            type: 'success',
            title: '成功',
            content: '新建成功',
            stayTime: 5
          })
          this.showModel = false
          this.getDemoDatas()
        } else {
          this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: res.message || '请检查必填项',
            stayTime: 5
          })
        }
      })
      }

      
    },
    cancelModel(){
      this.id = null
      this.showModel = false
      this.addFrom={
          name:'',
          remark:''
        }
    },
    deleteTag(item){

      this.$commonJs.doubleComfirm({
        content: '是否确定删除此标签？',
        successFun: msg => {
          this.$axiox.get('/api/topic/DelTopic?topicId=' + item.id).then(msg => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '删除成功',
              stayTime: 5
            })
            this.getDemoDatas()
          })
        },
        errorFun: msg => {
        }
      })

    },
    editTag(item){
      this.modelTitle = '编辑话题'
      this.addFrom={
          name:item.topicName,
          remark:item.remark
        }
        this.id = item.id
      this.showModel = true
    }
 }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/topicManager/topicList.vue